import React, { useEffect, useState } from "react";
import axios from "axios";
import { SealCheck, CaretUp, CaretDown, Minus } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EUReferencePrices = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/irish-markets/eu-reference-prices`, { timeout: 60000 })
      .then((res) => setData(res.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-white border border-[#E0D4C8] p-6 mb-8 animate-pulse" data-testid="eu-reference-loading">
        <div className="h-5 bg-[#E5E7EB] w-1/3 mb-4"></div>
        <div className="h-24 bg-[#F3F4F6]"></div>
      </div>
    );
  }
  if (!data || !data.available) return null;

  const weekLabel = data.prices[0]
    ? `Week ${data.prices[0].week_number} · ${new Date(data.prices[0].week_start).toLocaleDateString("en-IE", { day: "numeric", month: "short" })}–${new Date(data.prices[0].week_end).toLocaleDateString("en-IE", { day: "numeric", month: "short", year: "numeric" })}`
    : "";

  return (
    <div className="bg-white border-2 border-[#0F766E] mb-8" data-testid="eu-reference-prices">
      <div className="px-4 py-3 bg-[#0F766E] flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <SealCheck size={20} className="text-[#6EE7B7]" weight="fill" />
          <h2 className="font-serif text-lg text-white">Official EU Reported Prices — Ireland</h2>
          <span className="px-2 py-0.5 bg-[#6EE7B7] text-[#022C22] text-[10px] font-mono uppercase tracking-wide" data-testid="eu-official-tag">Official</span>
        </div>
        <span className="text-xs font-mono text-[#A7F3D0]">{weekLabel}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#E0D4C8] text-left">
              <th className="px-4 py-2 text-xs font-mono uppercase text-[#6B6661]">Category (grade)</th>
              <th className="px-4 py-2 text-xs font-mono uppercase text-[#6B6661] text-right">€/100kg</th>
              <th className="px-4 py-2 text-xs font-mono uppercase text-[#6B6661] text-right">≈ €/kg</th>
              <th className="px-4 py-2 text-xs font-mono uppercase text-[#6B6661] text-right">Weekly change</th>
            </tr>
          </thead>
          <tbody>
            {data.prices.map((p) => (
              <tr key={p.product_code} className="border-b border-[#F3F4F6] hover:bg-[#F9FAFB]" data-testid={`eu-price-${p.product_code}`}>
                <td className="px-4 py-2.5 text-sm text-[#111827]">{p.label} <span className="text-xs font-mono text-[#9CA3AF]">({p.product_code})</span></td>
                <td className="px-4 py-2.5 text-right font-mono text-sm text-[#111827]">€{p.price_eur_100kg.toFixed(2)}</td>
                <td className="px-4 py-2.5 text-right font-mono text-sm text-[#4B5563]">€{p.price_eur_kg.toFixed(2)}</td>
                <td className="px-4 py-2.5 text-right">
                  {p.change_percent === null ? (
                    <Minus size={12} className="inline text-[#9CA3AF]" />
                  ) : (
                    <span className={`inline-flex items-center gap-1 font-mono text-xs ${p.change_percent > 0 ? "text-[#059669]" : p.change_percent < 0 ? "text-[#DC2626]" : "text-[#4B5563]"}`}>
                      {p.change_percent > 0 ? <CaretUp size={11} weight="fill" /> : p.change_percent < 0 ? <CaretDown size={11} weight="fill" /> : null}
                      {p.change_percent > 0 ? "+" : ""}{p.change_percent}%
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-4 py-2 bg-[#F9FAFB] border-t border-[#E0D4C8]">
        <p className="text-[11px] text-[#6B6661]">
          Source: {data.source}. {data.grade_note} National weekly averages reported to the EU Commission — carcass weight.
        </p>
      </div>
    </div>
  );
};

export default EUReferencePrices;
